import { createInstagramFeed } from '../ig'

export function initHomepage() {
    console.log('Homepage initialized!')
    createInstagramFeed()
}
